import React from 'react';
import VendorShowContainer from '../../../Containers/UserContainer/VendorInfo';

const VendorShowScreen = () => {
  return <VendorShowContainer />;
};

export default VendorShowScreen;
